import { Routes, Route } from "react-router-dom";
import { OSCI0113001Q } from "@/tz/go/egaz/osci/ptl/intf/hist/OSCI0113001Q";
import { OSCI0113002S } from "@/tz/go/egaz/osci/ptl/intf/hist/OSCI0113002S";
import { OSCI0113004Q } from "@/tz/go/egaz/osci/ptl/intf/enpo/OSCI0113004Q";
import { OSCI0113008Q } from "@/tz/go/egaz/osci/ptl/intf/doc/OSCI0113008Q";
import { OSCI0113009S } from "@/tz/go/egaz/osci/ptl/intf/doc/OSCI0113009S";
import { OSCI0113010S } from "@/tz/go/egaz/osci/ptl/intf/doc/OSCI0113010S";
import { OSCI0113005S } from "../intf/enpo/OSCI0113005S";
import { OSCI0113006S } from "../intf/enpo/OSCI0113006S";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const ElctdocRouter = () => {
    return (
        <Routes>
            <Route path={"/hist/osci0113001q"} element={<OSCI0113001Q />} />
            <Route path={"/hist/osci0113002s/:trscLogId"} element={<OSCI0113002S />} />
            <Route path={"/doc/osci0113008q"} element={<OSCI0113008Q />} />
            <Route path={"/doc/osci0113009s"} element={<OSCI0113009S />} />
            <Route path={"/doc/osci0113010s/:intfId"} element={<OSCI0113010S />} />
            <Route path={"/enpo/osci0113004q"} element={<OSCI0113004Q />} />
            <Route path={"/enpo/osci0113005s"} element={<OSCI0113005S />} />
            <Route path={"/enpo/osci0113006s/:orgEnpoId"} element={<OSCI0113006S />} />
        </Routes>
    );
};
